import axios from "axios";
import { initAuth, isTokenValid } from "./AuthService";
import { logout } from "../redux/ApiSlice/Auth/AuthSlice";

let _store;
export const injectStore = (store) => { _store = store; };

// Holds the in-flight refresh promise so concurrent calls share one refresh
let refreshPromise = null;

const refreshOnce = () => {
    if (!refreshPromise) {
        refreshPromise = _store.dispatch(initAuth()).finally(() => {
            refreshPromise = null;
        });
    }
    return refreshPromise;
};

const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_MAIN_URL}api`,
    withCredentials: true,
});

axiosInstance.interceptors.request.use(
    async (config) => {
        let token = _store.getState().auth.accessToken;

        if (token && !isTokenValid(token)) {
            try {
                await refreshOnce();
                token = _store.getState().auth.accessToken;
            } catch {
                _store.dispatch(logout());
                return Promise.reject(new Error("Session expired"));
            }
        }

        if (config.headers && token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response) {
            const { status } = error.response;
            console.error(`HTTP Error: ${status}`);

            if (status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    await refreshOnce();
                    const newToken = _store.getState().auth.accessToken;
                    originalRequest.headers.Authorization = `Bearer ${newToken}`;
                    return axiosInstance(originalRequest);
                } catch {
                    _store.dispatch(logout());
                    return Promise.reject(error);
                }
            }
        } else {
            if (!navigator.onLine) {
                return Promise.reject(new Error("No internet connection. Please check your network and try again."));
            }
            console.error("Network error:", error.message);
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
